export const AuthRole = () => {
  const data = localStorage.getItem("pharmacyAuthToken");
  return JSON.parse(data!);
};

export const AuthRoleType = {
  owner: "clinic_owner",
  doctor: "doctor",
  staff: "staff",
  pharmacy: "pharmacy"
};
